import { Inject, Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { BASE_URL } from "./injection-tokens";
import { ErrorMessage } from "../models/errors";
import { Fax } from "../models/fax";
import { Store } from "@ngxs/store";
import { MessageService } from "primeng/api";
import { catchError, lastValueFrom, map, of } from "rxjs";

export abstract class FaxServiceBase
{
    abstract getFax(faxId: number) : Promise<Fax | undefined>;

}

@Injectable({
    providedIn: 'root'
  })
  export class FaxService extends FaxServiceBase
  {
    constructor
    (
      private _api: ApiService,      
      private _messages: MessageService,
      private _store: Store,
      @Inject(BASE_URL) private _baseUri: string,
    )
    {
      super()
    }


    override getFax(faxId: number): Promise<Fax | undefined> 
    {
        return lastValueFrom(
            this._api.makeAPIGetCall<Fax>(this._baseUri, "/util/faxes/" + faxId.toString())
            .pipe(
                catchError((error:ErrorMessage) => { this._messages.add({ key: 'main-alert', severity: 'errror', summary: 'Could Not Retrieve Fax', detail: ' ' + error.message }); return of(undefined)})
            )
        );
    }

  }